'use client';

import type { PropsWithChildren } from 'react';
import { SliderWrapper } from '@/components/shared/SliderWrapper';
import { SkeletonChild, SkeletonParent } from '@/components/ui/Skeleton/skeleton';
import { cn } from '@/utils/cn';

interface WrapperProps extends PropsWithChildren {
  className?: string;
}

interface RenderSliderParams {
  className?: string;
  count?: number;
}

const Wrapper = ({ children, className }: WrapperProps) => (
  <>
    <div className={cn('md:block hidden', className)}>
      {children}
    </div>
    <SkeletonParent className={cn('md:hidden block', className)}>
      <SkeletonChild />
    </SkeletonParent>
  </>
);

export const GmDailyStreakSkeleton = () => {
  const renderSliders = (params?: RenderSliderParams) => {
    const { className, count } = params ?? {};
    return (
      <div className={cn('w-fit flex gap-2', className)}>
        {
          Array.from({ length: count || 13 }).map(
            (_, i) => (
              <Wrapper key={i} className="relative max-md:w-14 max-md:h-16.5">
                <SkeletonParent className="rounded-full md:block hidden -top-2.5 z-1 absolute left-5">
                  <SkeletonChild className="size-14 rounded-[inherit]" />
                </SkeletonParent>
                <SkeletonParent className="rounded-2xl hidden min-w-25 h-29.5 relative md:flex justify-end items-center pb-2 flex-col gap-0.5">
                  <SkeletonChild className="h-[1.813rem] w-14" />
                  <SkeletonChild className="size-6 rounded-full" />
                </SkeletonParent>
              </Wrapper>
            ),
          )
        }
      </div>
    );
  };

  return (
    <div className="flex flex-col gap-2.5 md:gap-0">
      <SkeletonParent className="rounded-lg w-fit">
        <SkeletonChild className="rounded-[inherit] md:h-5.5 md:w-29.5 h-3 w-20" />
      </SkeletonParent>

      <div className="relative max-lg:-mx-4 max-lg:overflow-x-clip lg:-mx-10 3xl:mr-0 3xl:pr-0">

        <SliderWrapper className="-my-6 pb-5.25 pt-8.75 md:pt-12 md:pb-12 lg:pl-10">
          <div className="flex w-max lg:w-full px-4 lg:px-0 gap-2 grow flex-1 max-lg:min-w-[stretch]">
            <div className="w-fit flex gap-2 lg:pr-10 3xl:pr-0">
              {renderSliders({ className: 'md:flex hidden' })}
              {renderSliders({ className: 'md:hidden flex', count: 5 })}
            </div>
          </div>
        </SliderWrapper>
      </div>

    </div>
  );
};
